import api from "../api/api";
import { appState, dispatch } from "../redux/redux-config";

const messages = {
  loadMessages: async function (payload, userId) {
    try {
      if (userId) {
        const result = await api.messages.messageListForSpecificUser(payload, userId);
        if (result.success) {
          dispatch({
            type: "MESSAGES_LOADED",
            payload: {
              list: result.alerts,
              totalCount: result.totalCount,
              scheduledCount: result.scheduledCount,
            },
          });
          return result;
        }
      } else {
        const result = await api.messages.list(payload);
        if (result.success) {
          dispatch({
            type: "MESSAGES_LOADED",
            payload: {
              list: result.alerts,
              totalCount: result.totalCount,
              scheduledCount: result.scheduledCount,
            },
          });
          return result;
        }
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  },

  loadEmailAndSenderNames: async function () {
    try {
      const result = await api.messages.emailAndSenderNames();
      
      if (result.success) {
        return result.list || [];
      }
    } catch (error) {
      console.error("Error fetching email and sender names:", error);
      return [];
    }
  },
};
export default messages;

const initialState = {
  //   sync: {}, // Tracks sync/loading states
  messages: [], // List of messages
  totalCount: 0, // Total number of messages
  scheduledCount: 0,
  selectedMessage: null, // Message selected for bulk actions
  filters: [], // Filter options
  savedFilter: null // Persisted filter/search state for back-navigation
};

export function messageReducer(state = initialState, action) {
  if (state === undefined) return initialState;
  switch (action.type) {
    case "MESSAGES_LOADED":
      return {
        ...state,
        messages: action.payload.list,
        totalCount: action.payload.totalCount,
        scheduledCount: action.payload.scheduledCount,
      };

    case "MESSAGES_FILTER_SAVED":
      return { ...state, savedFilter: action.payload };

    case "MESSAGES_FILTER_CLEARED":
      return { ...state, savedFilter: null };

    default:
      return state;
  }
}
